import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => (
  <header className={'Header'}>
    <nav>
      <ul>
        <li><NavLink to="/" exact>Home</NavLink></li>
        <li><NavLink to="/studio">Studio</NavLink></li>
        <li><NavLink to="/work" exact>Work</NavLink></li>
        <li><NavLink to="/404" exact>Not found</NavLink></li>
      </ul>
    </nav>
  </header>
);

export default Header;
